export default {
  // gateway value must be boolean
  frequencies: [
    { value: '1', label: 'Annually', paytrace: true, multipass: true },
    { value: '8', label: 'Semi-Annually', paytrace: true, multipass: true },
    { value: 'A', label: 'Trimesterly', paytrace: true, multipass: false },
    { value: '2', label: 'Quarterly', paytrace: true, multipass: true },
    { value: '9', label: 'Bi-Monthly', paytrace: true, multipass: true },
    { value: '3', label: 'Monthly', paytrace: true, multipass: true },
    { value: '4', label: 'Bi-Weekly', paytrace: true, multipass: true },
    { value: '7', label: '1st and 15th', paytrace: true, multipass: false },
    { value: '5', label: 'Weekly', paytrace: true, multipass: true },
    { value: '6', label: 'Daily', paytrace: true, multipass: true },
  ],

  FREQUENCIES_MAP: {
    1: 'Annually',
    8: 'Semi-Annually',
    A: 'Trimesterly',
    2: 'Quarterly',
    9: 'Bi-Monthly',
    3: 'Monthly',
    4: 'Bi-Weekly',
    7: '1st and 15th',
    5: 'Weekly',
    6: 'Daily',
  },
};
